import axios from 'axios';

function errorHandler(error, reject) {
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}

const base_api_url = "korankirimanretur";

export default {

    list(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                // const keys = ['page', 'limit', 'sortBy', 'sortDir', 'customer_id', 'isReturKey', 'tgl1', 'tgl2', 'tglKrm1', 'tglKrm2', 'City', 'code', 'name', 'customer_group', 'nofaktur','no_return','codenama'];
                const keys = ['page', 'limit', 'sortBy', 'sortDir','customer_id', 'CustName', 'tgl1', 'tgl2', 'tglR1', 'tglR2', 'kota_id', 'kota_name', 'customer_group', 'no_return', 'createby', 'salesae_id', 'salesae_name'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/${base_api_url}${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                obj.retur_qty = meta.retur_qty;
                obj.retur_val = meta.retur_val;

                resolve(list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },

    save(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const {data} = await axios.post(`/${base_api_url}`, obj);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    }, 


    cekretur(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.post(`/${base_api_url}/cekretur`, obj);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },

    detail(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.post(`/${base_api_url}/detail`, obj);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    remove(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const resp = await axios.delete(`/${base_api_url}/${obj.returhdrKey}`);
                resolve(resp);
            } catch (error) {
                errorHandler(error, reject);
            }
        })
    },
    exportxls(obj = {}) {
        return new Promise((resolve, reject) => {
            try {
                // const keys = ['sortBy', 'sortDir', 'tgl1', 'tgl2', 'City', 'code', 'name', 'customer_group', 'nofaktur','no_return','codenama'];
                const keys = ['page', 'limit', 'sortBy', 'sortDir','customer_id', 'CustName', 'tgl1', 'tgl2', 'tglR1', 'tglR2', 'kota_id', 'kota_name', 'customer_group', 'no_return','createby', 'salesae_id', 'salesae_name'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }

                axios({
                    url: `/${base_api_url}/exportxls${str}`,
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'retur_konsinyasi.xlsx');
                    document.body.appendChild(link);
                    link.click();
                    // window.location.assign(url);
                    resolve(link);
                });

            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
}